var ellipsis = '...';
var ellipsisSize = ellipsis.length;

module.exports = function($container) {
  $container = $container || $('body');

  $container.find('[data-charlimit]').each(function() {
    var $el = $(this);
    var trimmableContent = false;
    var charlimit = $el.data('charlimit');

    trimmableContent |= processTag($el, charlimit);
    trimmableContent |= processText($el, charlimit);

    trimmableContent || console.warn('Can\'t trim', this);
  });
}

function processTag($el, charlimit) {
  var content = getTrimmableTagContent();
  content && content.length > charlimit
    && trimTagContent()
    && updateTitle($el, content);

  return content != '';

  function getTrimmableTagContent() {
    var content = $el.attr('tag');
    return content && content.trim();
  }

  function trimTagContent() {
    var newText = content.substring(0, charlimit - ellipsisSize) + ellipsis;
    $el.attr('tag', newText);

    return true;
  }
}

function processText($el, charlimit) {
  var content = getTrimmableTextContent();
  content && content.length > charlimit
    && trimTextContent()
    && updateTitle($el, content);

  return content != '';

  function getTrimmableTextContent() {
    var content = $el.contents().last().text();
    return content && content.trim();
  }

  function trimTextContent() {
    var newText = content.substring(0, charlimit - ellipsisSize) + ellipsis;
    $el.contents().last().replaceWith(newText);

    return true;
  }
}

function updateTitle($el, title) {
  $el.attr('title') || $el.attr('title', title);
}
